import { render, staticRenderFns } from "./LibBtnMenu.vue?vue&type=template&id=951b3fc4&scoped=true"
import script from "./LibBtnMenu.vue?vue&type=script&lang=js"
export * from "./LibBtnMenu.vue?vue&type=script&lang=js"
import style0 from "./LibBtnMenu.vue?vue&type=style&index=0&id=951b3fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951b3fc4",
  null
  
)

export default component.exports